import { post } from "@/utils/utils";
// 导购相关接口
const smartPurchase = {
  state: {},
  mutations: {
    QUERY_POTENTIAL_SKU_LIST() {},
    QUERY_SKU_LIST() {},
    BATCH_SAVE_REQURCHASE_SKU() {},
    QUERY_REQURCHASE_SKU_LIST() {},
    EDIT_REQURCHASE_SKU_CYCLE_VALUE() {},
    EDEL_REQURCHASE_SKU() {},
    SAVE_REQURCHASE_PLAN() {},
    QUERY_REQURCHASE_PLAN_LIST() {},
    OPERATE_REQURCHASE_PLAN() {},
    CHECK_REQURCHASE_PLANNAME() {},
    QUERY_REQURCHASE_PLAN_DETAILS() {},
    EDIT_REQURCHASE_PLAN() {},
    QUERY_REQURCHASE_POS_ORDER_LIST() {},
    QUERY_REQURCHASE_POS_ORDER_ALL_LIST() {},
    QUERY_REQURCHASE_PLAN_INFO_LIST() {},
    ADD_TO_REPURCHASE_PLAN() {},
    QUERY_REQURCHASE_PLAN_JOIN_LIST() {},
    QUERY_REQURCHASE_PLAN_RECORD_LIST() {},
    QUERY_REQURCHASE_PLAN_RECORD_NUM() {},
    QUERY_REQURCHASE_PLAN_MEMBER_RECORD_LIST() {},
    QUERY_REQURCHASE_PLAN_MEMBER_RECORD_CENSUS() {},
    QUERY_REQURCHASE_PLAN_CENSUS() {},
    QUERY_REQURCHASE_PLAN_CENSUS_NUM() {},
    QUERY_REQURCHASE_SKU_OFFLINE_ORDER_LIST() {},
    QUERY_ALL_REQURCHASE_SKU_OFFLINE_ORDER_LIST() {},
    QUERY_REQURCHASE_PLAN_SEND_MEMBER_LIST() {},
    QUERY_REQURCHASE_PLAN_SEND_MEMBER_DETAILS() {},
    QUERY_REQURCHASE_PLAN_DATA() {},
    QUERY_REQURCHASE_PLAN_DATA_REPORT() {},
    QUERY_REQURCHASE_PLAN_DATA_REPORT_STATUS() {},
    QUERY_REQURCHASE_ORDER_LIST() {},
    QUERY_ALL_REQURCHASE_ORDER_LIST() {},
    QUERY_REQURCHASE_PLAN_DIAGNOSIS() {},
    SAVE_REQURCHASE_PLAN_DIAGNOSIS() {},
    QUERY_SUGGEST_OPTIMIZE_SKU() {},
    SAVE_REQURCHASE_PLAN_SKU_ANALYSE() {},
    BATCH_SAVE_SKU_BY_IMPORT() {},
    QUERY_TRPUTVHSDR_MRMBER_LIST() {},
    RPUTVHSDR_ASSIGN_EMP() {},
    REQURCHASE_MEMBER_EXPORT() {},
    QUERY_REPURCHASE_STATISTICS() {},
    QUERY_REPURCHASE_EMPLOYEE_FOLLOW() {},
    QUERY_REPURCHASE_EMPLOYEE_DATA() {},
    QUERY_REPURCHASE_EMPLOYEE_MEMBER_LIST() {}
  },
  actions: {
    queryStorePotentialSkuInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryStorePotentialSkuInfoList`,
        name: "QUERY_POTENTIAL_SKU_LIST",
        params
      });
    },
    querySkuList({ commit }, params) {
      return post({
        commit,
        url: `/basic/spu/querySkuList`,
        name: "QUERY_SKU_LIST",
        params
      });
    },
    batchSaveRepurchaseSku({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/batchSaveRepurchaseSku`,
        name: "BATCH_SAVE_REQURCHASE_SKU",
        params
      });
    },
    queryStoreRepurchaseSkuInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryStoreRepurchaseSkuInfoList`,
        name: "QUERY_REQURCHASE_SKU_LIST",
        params
      });
    },
    editRepurchaseSkuCycleValue({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/editRepurchaseSkuCycleValue`,
        name: "EDIT_REQURCHASE_SKU_CYCLE_VALUE",
        params
      });
    },
    delRepurchaseSku({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/delRepurchaseSku`,
        name: "EDEL_REQURCHASE_SKU",
        params
      });
    },
    saveStoreRepurchasePlan({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/saveStoreRepurchasePlan`,
        name: "SAVE_REQURCHASE_PLAN",
        params
      });
    },
    queryStoreRepurchasePlanInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryStoreRepurchasePlanInfoList`,
        name: "QUERY_REQURCHASE_PLAN_LIST",
        params
      });
    },
    operateStoreRepurchasePlan({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/operateStoreRepurchasePlan`,
        name: "OPERATE_REQURCHASE_PLAN",
        params
      });
    },
    checkStoreRepurchasePlanName({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/checkStoreRepurchasePlanName`,
        name: "CHECK_REQURCHASE_PLANNAME",
        params
      });
    },
    queryStoreRepurchasePlanDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryStoreRepurchasePlanDetails`,
        name: "QUERY_REQURCHASE_PLAN_DETAILS",
        params
      });
    },
    editStoreRepurchasePlan({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/editStoreRepurchasePlan`,
        name: "EDIT_REQURCHASE_PLAN",
        params
      });
    },
    queryPotentialSkuPosOrderList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryPotentialSkuPosOrderList`,
        name: "QUERY_REQURCHASE_POS_ORDER_LIST",
        params
      });
    },
    queryPotentialSkuPosOrderAllList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryPotentialSkuPosOrderList`,
        name: "QUERY_REQURCHASE_POS_ORDER_ALL_LIST",
        params
      });
    },
    queryRepurchasePlanInfoPageList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchasePlanInfoPageList`,
        name: "QUERY_REQURCHASE_PLAN_INFO_LIST",
        params
      });
    },
    addToRepurchasePlan({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/addToRepurchasePlan`,
        name: "ADD_TO_REPURCHASE_PLAN",
        params
      });
    },
    queryPotentialSkuJoinPlanList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryPotentialSkuJoinPlanList`,
        name: "QUERY_REQURCHASE_PLAN_JOIN_LIST",
        params
      });
    },
    queryRepurchasePlanExecRecordList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchasePlanExecRecordList`,
        name: "QUERY_REQURCHASE_PLAN_RECORD_LIST",
        params
      });
    },
    queryRepurchasePlanExecRecordNum({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchasePlanExecRecordCensusNum`,
        name: "QUERY_REQURCHASE_PLAN_RECORD_NUM",
        params
      });
    },
    queryRepurchasePlanExecMemberRecordList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchasePlanExecMemberRecordList`,
        name: "QUERY_REQURCHASE_PLAN_MEMBER_RECORD_LIST",
        params
      });
    },
    getRepurchasePlanExecRecordCensus({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/getRepurchasePlanExecRecordCensus`,
        name: "QUERY_REQURCHASE_PLAN_MEMBER_RECORD_CENSUS",
        params
      });
    },
    getRepurchasePlanCensus({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/getRepurchasePlanCensus`,
        name: "QUERY_REQURCHASE_PLAN_CENSUS",
        params
      });
    },
    getRepurchasePlanCensusNum({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/getRepurchasePlanCensusNum`,
        name: "QUERY_REQURCHASE_PLAN_CENSUS_NUM",
        params
      });
    },
    getRepurchaseSkuOfflineOrderList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/getRepurchaseSkuOfflineOrderList`,
        name: "QUERY_REQURCHASE_SKU_OFFLINE_ORDER_LIST",
        params
      });
    },
    getAllRepurchaseSkuOfflineOrderList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/getRepurchaseSkuOfflineOrderList`,
        name: "QUERY_ALL_REQURCHASE_SKU_OFFLINE_ORDER_LIST",
        params
      });
    },
    getRepurchasePlanSendMemberList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/getRepurchasePlanSendMemberList`,
        name: "QUERY_REQURCHASE_PLAN_SEND_MEMBER_LIST",
        params
      });
    },
    getRepurchasePlanSendMemberDetails({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/getRepurchasePlanSendMemberDetails`,
        name: "QUERY_REQURCHASE_PLAN_SEND_MEMBER_DETAILS",
        params
      });
    },
    queryRepurchasePlanExecData({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchasePlanExecData`,
        name: "QUERY_REQURCHASE_PLAN_DATA",
        params
      });
    },
    queryRepurchasePlanExecDataByStoreCode({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchasePlanExecDataByStoreCode`,
        name: "QUERY_REQURCHASE_PLAN_DATA_REPORT",
        params
      });
    },
    queryRepurchasePlanExecDataByQueryStatus({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchasePlanExecDataByQueryStatus`,
        name: "QUERY_REQURCHASE_PLAN_DATA_REPORT_STATUS",
        params
      });
    },
    queryRepurchaseOrderList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchaseOrderList`,
        name: "QUERY_REQURCHASE_ORDER_LIST",
        params
      });
    },
    queryAllRepurchaseOrderList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchaseOrderList`,
        name: "QUERY_ALL_REQURCHASE_ORDER_LIST",
        params
      });
    },
    queryRepurchasePlanDiagnosisConfig({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchasePlanDiagnosisConfig`,
        name: "QUERY_REQURCHASE_PLAN_DIAGNOSIS",
        params
      });
    },
    saveRepurchasePlanDiagnosisConfig({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/saveRepurchasePlanDiagnosisConfig`,
        name: "SAVE_REQURCHASE_PLAN_DIAGNOSIS",
        params
      });
    },
    querySuggestOptimizeSkuList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/querySuggestOptimizeSkuList`,
        name: "QUERY_SUGGEST_OPTIMIZE_SKU",
        params
      });
    },
    queryRepurchaseSkuAnalyse({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchaseSkuAnalyse`,
        name: "SAVE_REQURCHASE_PLAN_SKU_ANALYSE",
        params
      });
    },
    batchSaveRepurchaseSkuByImport({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/batchSaveRepurchaseSkuByImport`,
        name: "BATCH_SAVE_SKU_BY_IMPORT",
        params
      });
    },
    queryRepurchaseMemberInfoList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchaseMemberInfoList`,
        name: "QUERY_TRPUTVHSDR_MRMBER_LIST",
        params
      });
    },
    assignEmployee({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/assignEmployee`,
        name: "RPUTVHSDR_ASSIGN_EMP",
        params
      });
    },
    repurchaseMemberSkuListExport({ commit }, params) {
      return post({
        commit,
        url: `/reports/daystatOrderDetails/repurchaseMemberSkuListExport`,
        name: "REQURCHASE_MEMBER_EXPORT",
        params
      });
    },
    queryRepurchaseStatistics({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchaseStatistics`,
        name: "QUERY_REPURCHASE_STATISTICS",
        params
      });
    },
    queryRepurchaseEmployeeFollowMemberStatistics({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchaseEmployeeFollowMemberStatistics`,
        name: "QUERY_REPURCHASE_EMPLOYEE_FOLLOW",
        params
      });
    },
    queryRepurchaseEmployeeFollowMemberData({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchaseEmployeeFollowMemberData`,
        name: "QUERY_REPURCHASE_EMPLOYEE_DATA",
        params
      });
    },
    queryRepurchaseEmployeeMemberList({ commit }, params) {
      return post({
        commit,
        url: `/store/repurchase/queryRepurchaseEmployeeMemberList`,
        name: "QUERY_REPURCHASE_EMPLOYEE_MEMBER_LIST",
        params
      });
    }
  }
};

export default smartPurchase;
